import React, {useEffect, useState} from 'react';
import axios from "axios";

import './styles.scss';

import { Container, Row, Col, Modal, ModalHeader, ModalBody, Button } from "reactstrap";

import Banner from "../../components/Banner/Banner";
import CardBurger from "../../components/CardBurger/CardBurger";
import CardExtras from "../../components/CardExtras/CardExtras";

const Burgers = () => {
    const [burgers, setBurgers] = useState([]);
    const [extras, setExtras] = useState([]);
    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);

    useEffect(() => {
        const fetchBurgersData = async () => {
            const response = await axios.get("https://hutch.com.ar/api/burgers.php");
            setBurgers(response.data);
        }
        const fetchExtrasData = async () => {
            const response = await axios.get("https://hutch.com.ar/api/extras.php");
            setExtras(response.data);
        }

        fetchBurgersData()
        fetchExtrasData()
    }, [])

    const renderModal = () => (
        <Modal isOpen={modal} toggle={toggle} centered={true} className="modal-sin-tacc">
            <ModalHeader toggle={toggle}>AVISO IMPORTANTE</ModalHeader>
            <ModalBody>
                <p><strong>Pan sin “tacc”</strong></p>
                <p>El pan <strong>“sin TACC”</strong> es un producto opcional para todas las hamburguesas de nuestro menú, pero <strong>“Hutch”</strong> no ofrece un combo <strong>“sin TACC”</strong>.</p>
                <p>El pan <strong>“sin TACC”</strong> es elaborado y envasado “al vacío” por nuestros proveedores en sus plantas de elaboración certificadas.</p>
                <p>Si el envoltorio o envase del pan <strong>“sin TACC”</strong> está abierto o dañado no lo consuma y dé aviso inmediato a nuestro personal ubicado en el local.</p>
                <p>La carne de la hamburguesa, las papas fritas y todos los demás ingredientes de nuestro menú podrían contener <strong>“TACC”</strong> por exposición a la contaminación cruzada ya que no contamos con una cocina adaptada para la elaboración de productos <strong>“sin TACC”</strong>.</p>
                <p>Ante la menor duda, no consuma el producto.</p>
                <p><strong>“Hutch”</strong> no se responsabiliza por las consecuencias negativas que pudiera ocasionar en la salud del consumidor la inobservancia de estas advertencias.</p>
                <p>Por consultas dirigirse a <a href="mailto:infohutchbar@gmail.com">infohutchbar@gmail.com</a>.</p>
            </ModalBody>
        </Modal>
    );

    return (
        <main>
            {renderModal()}
            <Banner page="burgers" title="BURGERS"/>
            <Container className="pt-3 pt-md-5" id="burgers">
                <Row>
                    <Col xs="12" className="text-center">
                        <p className='sin-tacc'>"También podes elegir tu combo con PAN SIN TACC" - <Button color="link" onClick={toggle}>Ver términos y condiciones</Button></p>
                    </Col>
                </Row>
                <Row>
                    {burgers.map(burger => burger.active === "1" && (
                        <CardBurger burger={burger} />
                    ))}
                </Row>
            </Container>
            {extras.length > 0 && (
                <CardExtras extras={extras}/>
            )}
        </main>
    );
}

export default Burgers;